import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { uploadTempFileForAdmin } from 'src/app/root-store/jobseeker-store/jobseeeker-profile-for-admin/actions';
import { setFileSizeValidation, uploadTempFile } from 'src/app/root-store/jobseeker-store/jobseeker-profile/actions';
import { AppState } from 'src/app/root-store/state';

@Injectable({
  providedIn: 'root'
})
export class JobseekerFileService {

  public uploadTempFile(event, fileLimit){
    this.uploadFile(event.target.files[0], fileLimit);
  }

  public uploadTempFileForAdmin(event, fileLimit, jobseekerId){
    this.uploadFileForAdmin(event.target.files[0], fileLimit, jobseekerId);
  }

  public uploadFile(file: File | undefined, fileLimit: number){
    const fd = this.validateFile(file, fileLimit);
    if(fd){
      this.store.dispatch(uploadTempFile({payload: fd}));
    }
  }

  public uploadFileForAdmin(file: File | undefined, fileLimit: number, jobseekerId){
    const fd = this.validateFile(file, fileLimit);
    if(fd){
      fd.append('jobseekerId', jobseekerId);
      this.store.dispatch(uploadTempFileForAdmin({payload: fd }));
    }
  }

  // stores whether the file fits the limit; returns the form data to upload, or null when there is nothing to upload
  private validateFile(file: File | undefined, fileLimit: number): FormData | null {
    let fileSize = file ? file.size : 0;
    let isFileSizeValid = fileLimit > fileSize;
    this.store.dispatch(setFileSizeValidation({payload: isFileSizeValid}));

    if(!file || !isFileSizeValid){
      return null;
    }

    const fd = new FormData();
    fd.append('file', file);
    return fd;
  }
  
  constructor(private store: Store<AppState>) { }
}
